import * as classNames from 'classnames';
import { ContentEditable } from 'components/content';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('../LeadNotes.css');

// Component
@inject('store')
@observer
export class LeadNoteNew extends React.Component<IAppOnlyStore, {}> {
  constructor(props: IAppOnlyStore) {
    super(props);
  }

  @computed private get isReady(): boolean {
    return this.props.store.lead.newNote.text.trim().length > 0;
  }

  public render() {
    const { lead } = this.props.store;

    return (
      <div className={classNames(s.note, s.new)}>
        <div className={s.noteContent}>
          <ContentEditable
            classNameForField={classNames(s.content, s.contentEditable)}
            onChange={this.handleNewNoteChange}
            autoFocus={true}
            placeholder="New note..."
            html={lead.newNote.html || ''}
            selectTextOnFirstFocus={true}
            contentEditable={true}
          />
        </div>

        <div className={s.noteDetails}>
          <div className={s.detail}>
            <div className={s.left}>
              {lead.newNote.error && (
                <p className="text textImportant">
                  Could not save the note, try again
                </p>
              )}

              <SavingIndicator
                align="left"
                labels={{
                  saving: 'Saving note...',
                  error: 'Note text is required',
                }}
                status={
                  lead.newNote.errorAllFieldsRequired
                    ? SavingIndicatorStatus.Error
                    : lead.newNote.isSaving
                    ? SavingIndicatorStatus.Saving
                    : SavingIndicatorStatus.None
                }
              />
            </div>

            <div
              className={classNames(s.right, s.saveButtons, {
                [s.saving]: lead.newNote.isSaving,
              })}
            >
              {lead.newNote.html.length > 0 && (
                <button
                  className={classNames('boxButton', 'boxButtonImportant')}
                  onClick={
                    lead.newNote.isSaving
                      ? undefined
                      : this.handleNewNoteClearContent
                  }
                >
                  Clear note text
                </button>
              )}

              <button
                className={classNames('boxButton', s.publish)}
                onClick={this.handleNewNotePublish}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  @action private handleNewNoteChange = (html: string, text: string) => {
    this.props.store.lead.newNote.html = html;
    this.props.store.lead.newNote.text = text;
    this.props.store.lead.newNote.errorAllFieldsRequired = false;
  };

  private handleNewNoteClearContent = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    this.props.store.lead.clearNewLeadNote();
  };

  private handleNewNotePublish = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (this.isReady) {
      this.props.store.lead.addLeadNote();
    } else {
      this.props.store.lead.newNote.errorAllFieldsRequired = true;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteNew.tsx